import { createSlice } from "@reduxjs/toolkit";
import { todaysTasks, completeTask } from "../../api/APIServices";
import { API_STATUS } from "../../constants";

const initialState = {status:API_STATUS.IDEL, isCompleteTask:false, tasks:[]};
const todaysTaskSlice = createSlice({
    name:'todaysTasks',
    initialState,
    reducers:{ },
    extraReducers:(builder)=>{
        builder.addCase(todaysTasks.fulfilled, (state, action)=> {
            state.tasks = action.payload;
            state.isCompleteTask = false;
            state.status = API_STATUS.SUCCESS;
        }),
        builder.addCase(todaysTasks.pending, (state)=> {
            state.status = API_STATUS.PENDING;
        }),
        builder.addCase(todaysTasks.rejected, (state)=> { 
            state.status = API_STATUS.ERROR;
        })

        builder.addCase(completeTask.fulfilled, (state, action)=> {
            state.isCompleteTask = true;
            state.status = API_STATUS.SUCCESS;
        }),
        builder.addCase(completeTask.pending, (state)=> {
            state.status = API_STATUS.PENDING;
        }),
        builder.addCase(completeTask.rejected, (state)=> { 
            state.status = API_STATUS.ERROR;
        })
    }
});

export const {} = todaysTaskSlice.actions;
export default todaysTaskSlice.reducer;